import RootRouter from "./router/RootRouter";
import './App.css';
import {ThemeProvider} from "@mui/material/styles";
import theme from "./theme/muiTheme";
import CssBaseline from '@mui/material/CssBaseline';
import {Toaster} from "react-hot-toast";
import './global.css';


function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <RootRouter/>
                <Toaster
                    position="top-center"
                    reverseOrder={false}
                    toastOptions={{
                        duration: 4000,
                        style: {
                            borderRadius: '8px',
                            padding: '12px 16px',
                            fontSize: '14px',
                            fontWeight: 500,
                        },
                    }}
                />
        </ThemeProvider>
    );
}

export default App;
